export default __webpack_public_path__ + "static/media/nodes.6ee1cc68.svg";